import { Checkbox, Flex, FormControl, FormLabel, Input, Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { useState } from 'react'
import { WhiteBox } from '../../../../../../components/WhiteBox'
import { BoxMultiText } from '../BoxMultiText'
import { ModalTag } from '../ModalTag'

export interface iTextosPesquisa {
  texto: string
  participantes: number[]
}

export interface iConfiguracaoFeedback {
  participanteId: string
  reuniaoId?: string
  dataInicio: string
  tipoRespondente: number
  visualizarResposta: boolean
  edicaoResposta: number[]
  textosEmail: iTextosPesquisa[]
  textosAbertura: iTextosPesquisa[]
}

export const textoPadraoEmail = '<p><strong>Olá, [NOME DO RESPONDENTE]!</strong></p><p><strong>Você está recebendo um link para preenchimento relacionado ao feedback entre você e o [NOME DO AVALIADO].</strong></p><p><strong>Para preencher o feedback clique no link abaixo:</strong></p><p><strong><a>[LINK]</a></strong></p><p><strong>Qualquer dúvida contacte o responsável!</strong></p>'
export const textoPadraoAbertura = '<p><strong>Bem vindo ao questionário relacionado ao feedback entre o colaborador [NOME DO AVALIADO] e o colaborador [NOME DO RESPONDENTE]</strong></p>'

interface iProps {
  model: iConfiguracaoFeedback
  onChange: (model: iConfiguracaoFeedback) => void
  onPrevisualizar: (gestor: boolean) => void
  exibirDataInicio?: boolean
}

export const FormConfiguracaoFeedback: React.FC<iProps> = ({ model, onChange, onPrevisualizar, exibirDataInicio, children }) => {
  const [ModalTagIsOpen, setModalTagIsOpen] = useState(false)

  function AdicionarRespondente(tipoRespondente: number): void {
    if (model.edicaoResposta.includes(tipoRespondente)) {
      onChange({ ...model, edicaoResposta: [...model.edicaoResposta.filter(t => t !== tipoRespondente)] })
    } else {
      onChange({ ...model, edicaoResposta: [...model.edicaoResposta, tipoRespondente] })
    }
  }

  return (
    <>
      <ModalTag
        isOpen={ModalTagIsOpen}
        onClose={() => setModalTagIsOpen(false)}
      />

      <WhiteBox>
        <h2>Configuração do feedback</h2>
        <Flex mt={'2rem'} flexDir={'column'} gap={'2rem'}>
          {children}

          {exibirDataInicio &&
            <FormControl alignItems={'center'} as={Flex} gap={'1rem'}>
              <FormLabel margin={0}>Data de início</FormLabel>
              <Input
                onChange={(e) => onChange({ ...model, dataInicio: e.target.value })}
                width={'30%'}
                min={new Date().toISOString().slice(0, 16)}
                max={'2099-12-31T23:59'}
                type={'datetime-local'}
                value={model.dataInicio}
              />
            </FormControl>
          }

          <Flex flexDir={'column'}>
            <FormLabel>Quem deve responder ao feedback?</FormLabel>
            <RadioGroup
              value={model.tipoRespondente?.toString() ?? '0'}
              onChange={(e) => onChange({
                ...model,
                tipoRespondente: parseInt(e),
                textosEmail: [{
                  participantes: [0, 1],
                  texto: model.textosEmail[0].texto
                }],
                textosAbertura:
                [{
                  participantes: [0, 1],
                  texto: model.textosAbertura[0].texto
                }]
              })}
            >
              <Stack gap={'1rem'} direction={'row'}>
                <Radio value={'0'}>Somente eu</Radio>
                <Radio value={'1'}>Somente o convidado</Radio>
                <Radio value={'2'}>Eu e o convidado</Radio>
              </Stack>
            </RadioGroup>
          </Flex>

          <FormControl as={Flex} gap='.5rem'>
            <Checkbox
              onChange={() => onChange({ ...model, visualizarResposta: !model.visualizarResposta })}
              isChecked={model.visualizarResposta}
            />
            <FormLabel margin={0}>O participante pode visualizar respostas do formulário</FormLabel>
          </FormControl>

          <Flex flexDir={'column'}>
            <FormLabel>Quem pode editar as respostas</FormLabel>
            <Flex gap={'1rem'}>
              <FormControl w={'auto'} gap={'.5rem'} as={Flex}>
                <Checkbox isChecked={model.edicaoResposta.includes(0)} onChange={() => AdicionarRespondente(0)} />
                <FormLabel margin={0}>Eu</FormLabel>
              </FormControl>

              <FormControl w={'auto'} gap={'.5rem'} as={Flex}>
                <Checkbox isChecked={model.edicaoResposta.includes(1)} onChange={() => AdicionarRespondente(1)} />
                <FormLabel margin={0}>Convidado</FormLabel>
              </FormControl>
            </Flex>
          </Flex>
        </Flex>
      </WhiteBox>

      <WhiteBox>
        <BoxMultiText
          titulo='Texto para o convite por e-mail'
          descricao='Esse texto será apresentado no e-mail ou notificação antes do respondente abrir a pesquisa.'
          model={model.textosEmail}
          textoPadrao={textoPadraoEmail}
          onChange={(e) => onChange({ ...model, textosEmail: e })}
          openModalTag={() => setModalTagIsOpen(true)}
          ocultarParticipantes={model.tipoRespondente !== 2}
        />
      </WhiteBox>

      <WhiteBox>
        <BoxMultiText
          titulo='Texto de abertura antes do preenchimento'
          descricao='Esse texto será apresentado quando o respondente abrir o link antes de começar a responder a pesquisa, para ver exatamente como irá ficar, você pode pré-visualizar clicando no botão a baixo da caixa de edição de texto.'
          model={model.textosAbertura}
          textoPadrao={textoPadraoAbertura}
          onChange={(e) => onChange({ ...model, textosAbertura: e })}
          openModalTag={() => setModalTagIsOpen(true)}
          onPrevisualizar={onPrevisualizar}
          ocultarParticipantes={model.tipoRespondente !== 2}
        />
      </WhiteBox>
    </>
  )
}
